import ExcelJS from 'exceljs';
import { formatDateTime } from './dateUtils';

const HEADER_COLOR = 'FF667EEA';

export const exportRowsToExcel = async ({ sheetName, columns, rows, filename }) => {
  const workbook = new ExcelJS.Workbook();
  workbook.creator = 'Rettzy';
  workbook.created = new Date();

  const sheet = workbook.addWorksheet(sheetName, {
    views: [{ state: 'frozen', xSplit: 0, ySplit: 1 }],
  });

  sheet.columns = columns.map(({ header, key, width }) => ({ header, key, width }));

  const headerRow = sheet.getRow(1);
  headerRow.eachCell((cell) => {
    cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: HEADER_COLOR } };
    cell.font = { bold: true, color: { argb: 'FFFFFFFF' } };
    cell.alignment = { vertical: 'middle', horizontal: 'left' };
  });
  headerRow.height = 22;

  rows.forEach((row) => sheet.addRow(row));

  columns.forEach(({ key, numFmt }) => {
    if (numFmt) sheet.getColumn(key).numFmt = numFmt;
  });

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = `${filename}.xlsx`;
  anchor.click();
  URL.revokeObjectURL(url);
};

export const exportCommissionDetailsExcel = (commission, { featureLabel }) =>
  exportRowsToExcel({
    sheetName: 'Staff Commission',
    filename: `${featureLabel}-commission-${commission.settlementMonth}`,
    columns: [
      { header: 'Staff Member', key: 'staffMember', width: 28 },
      { header: 'Settlement Month', key: 'settlementMonth', width: 20 },
      { header: 'Created At', key: 'createdAt', width: 22 },
      { header: 'Commission Amount', key: 'commissionAmount', width: 20, numFmt: '#,##0.00' },
    ],
    rows: (commission.staffCommissions || []).map((row) => ({
      staffMember: row.user?.name || '—',
      settlementMonth: commission.settlementMonth || '',
      createdAt: row.createdAt ? formatDateTime(row.createdAt) : '',
      commissionAmount: parseFloat(row.commissionAmount) || 0,
    })),
  });
